import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { css } from "styled-components";

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            .react-datetime-picker__wrapper {
                width: 100%;
            }
            .react-datetime-picker__inputGroup {
                width: 70%;
            }
            .react-datetime-picker__button {
                width: 15%;
            }
        `,
    },
    calendarIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
    clearIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
};
scheduleReminderModalStyles.endDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            .react-datetime-picker__wrapper {
                width: 100%;
            }
            .react-datetime-picker__inputGroup {
                width: 70%;
            }
            .react-datetime-picker__button {
                width: 15%;
            }
        `,
    },
    calendarIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
    clearIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
};
